
import { Injectable } from '@angular/core';

@Injectable()
export class FormValuesService {

  constructor(){}

  public setValue( key : string, val : any ){
    window.localStorage.setItem( key, val );
  }

  public getValue( key ) : string {
    return window.localStorage.getItem( key );
  }

  public hasValue( key ) : boolean{
    return window.localStorage.getItem( key ) !== null;
  }
  
  /* The form jsons we get don't have all the necessary fields
   * for creating a valid request. Therefore we use some hardcoded
   * values to update it. This shouldn't be needed but is.
   */
  public sanitizeRequestValues( requestValues ){
    let requestValuesFinal = {};
    let requstValuesProper = {
      "vorname": "Peter",
      "nachname": "Testkunde",
      "geburtsdatum": "01.01.1980",
      "geschlecht": 1,
      "bundesland": "Bayern",
      "berufsgruppe": 1,
      "arbeitsstaetteOst": false,
      "steuerklasse": 1,
      "kinderVorhanden": false,
      "kinderfreibetrag": 0,
      "kstPflicht": true,
      "monatsbruttoentgelt": 3000,
      "bruttoRvPflichtig": 3000,
      "bruttoKvPflichtig": 3000,
      "bruttoSteuerPflichtig": 3000,
      "rvPflichtig": true,
      "avPflichtig": true,
      "kvArt": 1,
      "zusatzbeitragGkv": 1.1,
      "beitragPkv": 0,
      "beitragPkvAbsetzbar": 0,
      "monatsNettoentgelt": 0,
      "versorgungszielEm": 1650,
      "versorgungszielAlter": 1800,
      "kapitalbedarfUnfall": 350000,
      "eintrittBerufsleben": 2000,
      "lueckenImVersicherungsverlauf": 0,
      "lfzKrankheitsfall": 42,
      "anspruchGrvBekannt": false,
      "anspruchGrvEm": 0,
      "anspruchGrvAv": 0,
      "gewuenschterRentenbeginn": 65,
      "restleistungsvermoegenGrv": 0,
      "inflationsrate": 1.5
    };

    for( let key in requstValuesProper ){
      if( key in requestValues ){
        requestValuesFinal[key] = requestValues[key];
      }else{
        console.log( 'form JSON is missing: ' + key );
        requestValuesFinal[key] = requstValuesProper[key];
      }
    }

    console.log( 'time' );
    console.log( requestValuesFinal['geburtsdatum'] );

    return requestValuesFinal;
  }
  
}



// WEBPACK FOOTER //
// ./src/app/services/form-values/form-values.service.ts